
import { css } from 'lit';
export default css`
:host {
  width: inherit;
}

.alphabet-listing__listings-container {
    scroll-behavior: smooth;
  }

.alphabet-listing__listings-container {
  overflow-y: scroll;
}
`;